import type { BadgeVariant } from '@ui'

/**
 * Product vocabulary → library badge hue.
 *
 * The screens talk in domain terms — a score band, an entry status, an accent —
 * and the shared Badge takes a colour name. Keeping the translation in one place
 * means a band's colour is decided once rather than re-argued per screen, and
 * the product accent moves with a single edit.
 */
export type BadgeTone =
  | 'neutral'
  | 'accent'
  | 'high'
  | 'medium'
  | 'low'
  | 'conflict'
  | 'warning'
  | 'danger'
  | 'error'

const VARIANTS: Record<BadgeTone, BadgeVariant> = {
  neutral: 'grey',
  accent: 'green',
  high: 'green',
  medium: 'yellow',
  low: 'grey',
  /*
   * Conflict is not a level of confidence — the sources disagree beyond
   * sampling error and a human has to decide. It needs its own hue, distinct
   * from Medium's yellow and from an error's red, because it is neither.
   */
  conflict: 'orange',
  warning: 'yellow',
  danger: 'red',
  error: 'red',
}

export const badgeVariant = (tone: BadgeTone | string): BadgeVariant =>
  VARIANTS[tone as BadgeTone] ?? 'grey'
